<template>
    <div class="main-wrapper">
        <el-scrollbar class="table-content">
            <el-table :data="promotionList" class="customTable">
                <el-table-column prop="content" label="考试内容"></el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="primary" :underline="false" @click="viewScoreDetail(scope.row)"
                                     class="view-detail">查看详情
                            </el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.score}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="viewScoreDetail(scope.row)"
                                 class="view-detail">评分详情
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-table :data="answerList" class="customTable">
                <el-table-column prop="content" label="考试内容">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="分析问题">
                    <template slot-scope="scope">
                        <span>{{scope.row.question}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.answer}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="正确答案" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.rightAnswer}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.score}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-table :data="lastList" class="customTable">
                <el-table-column prop="content" label="考试内容" width="160">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="point" label="考点" width="160">
                    <template slot-scope="scope">
                        <span v-if="scope.row.showPoint">{{scope.row.point}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fillContent" label="填写内容" width="440"></el-table-column>
                <el-table-column label="学生提交答案" align="left" width="330">
                    <template slot-scope="scope">
                        <span class="show-text">{{scope.row.answer}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="正确答案" align="left">
                    <template slot-scope="scope">
                        <span class="show-text">{{scope.row.rightAnswer}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.score}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>
        <el-dialog title="评分详情（选择评分评委同时对学生进行评分，去掉最高分和最低分，剩下分数的平均分作为该学生成绩）"
                   :visible.sync="scoreDetailDialog" width="830px" @close="handleClose"
                   custom-class="green-dialog goods-score-dialog">
            <div class="upload-file-content">
                <el-table :data="ScoreList" class="customTable goods-text-table" style="width: 100%; flex: 1;"
                          height="1%"
                          :header-cell-style="{fontWeight: 'normal', height: '40px', color: '#333', background: '#F2F3FA',fontSize: '14px'}"
                          :cell-style="{fontSize: '14px',color: '#333333',height: '40px'}">
                    <el-table-column prop="name" label="评委名称" align="left"></el-table-column>
                    <el-table-column prop="score" label="分数" align="center"></el-table-column>
                    <el-table-column prop="time" label="评分时间" align="center"></el-table-column>
                </el-table>
                <pagination class="pages-center" :total="total" @current-change="handleCurrentChange"/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pagination from "../../../pagination";

    export default {
        name: "NetworkPromote",
        components: {
            pagination
        },
        data() {
            return {
                promotionList: [
                    {
                        content: '软文推广',
                        score: 15,
                    },
                    {
                        content: '短视频推广',
                        score: 15,
                    },
                ],
                answerList: [
                    {
                        content: '用户分析',
                        question: '年龄范围',
                        answer: '20~30岁',
                        rightAnswer: '20~30岁',
                        score: '8'
                    },
                    {
                        content: '用户分析',
                        question: '地域分布',
                        answer: '福建、上海、北京',
                        rightAnswer: '福建、上海、北京',
                        score: '8'
                    },
                    {
                        content: '用户分析',
                        question: '性别比例',
                        answer: '男 60%女 40%',
                        rightAnswer: '男 60%女 40%',
                        score: '8'
                    },
                    {
                        content: '用户分析',
                        question: '款式喜好',
                        answer: '款式、款式、款式',
                        rightAnswer: '款式、款式、款式',
                        score: '8'
                    },

                ],
                lastList: [
                    {
                        content: '用户分析',
                        point: '直播间管理',
                        fillContent: '标题',
                        answer: '标题标题标题标题标题标题标题标题标题',
                        rightAnswer: '标题标题标题标题标题标题标题标题标题',
                        score: '8',
                        showPoint: true,
                    },
                    {
                        content: '用户分析',
                        point: '直播间管理',
                        fillContent: '开播时间',
                        answer: '2021-12-21',
                        rightAnswer: '2021-12-21',
                        score: '8',
                        showPoint: false,
                    }, {
                        content: '用户分析',
                        point: '直播间管理',
                        fillContent: '开播时间',
                        answer: '2021-12-21',
                        rightAnswer: '2021-12-21',
                        score: '8',
                        showPoint: false,
                    }, {
                        content: '用户分析',
                        point: '直播间管理',
                        fillContent: '主播昵称',
                        answer: '大爷',
                        rightAnswer: '大爷',
                        score: '8',
                        showPoint: false,
                    }, {
                        content: '用户分析',
                        point: '直播间管理',
                        fillContent: '主播微信号',
                        answer: '大叶子',
                        rightAnswer: '大叶子',
                        score: '8',
                        showPoint: false,
                    }, {
                        content: '用户分析',
                        point: '商品库',
                        fillContent: '商品标题',
                        answer: '标题标题标题标题标题标题标题标题标题',
                        rightAnswer: '标题标题标题标题标题标题标题标题标题',
                        score: '8',
                        showPoint: true,
                    }, {
                        content: '用户分析',
                        point: '商品库',
                        fillContent: '价格形式',
                        answer: '99.99',
                        rightAnswer: '99.99',
                        score: '8',
                        showPoint: false,
                    }, {
                        content: '用户分析',
                        point: '商品库',
                        fillContent: '商品链接',
                        answer: '链接',
                        rightAnswer: '链接',
                        score: '8',
                        showPoint: false,
                    },
                ],
                scoreDetailDialog: false,
                ScoreList: [],
                total: 0,
                currentPageNum: 1
            }
        },
        methods: {
            viewScoreDetail(row) {
                this.scoreDetailDialog = true
            },
            handleClose() {
                this.scoreDetailDialog = false
            },
            //切换分页
            handleCurrentChange(val) {
                this.currentPageNum = val;
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-wrapper {
        height: 100%;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;

        .table-content {
            height: 100%;

            ::v-deep > .el-scrollbar__wrap {
                overflow-x: hidden;
            }

            .customTable {
                width: 100%;
                flex: 1;
                margin-top: 20px;

                .show-text {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .upload-file-content {
            height: 100%;

            .pages-center {
                margin-bottom: 0;
            }
        }
    }
</style>